// extracted by mini-css-extract-plugin
export default {"recos":"i3-z","productCardOverride":"j3-z","rowHasBadge":"k3-z"};